exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".item[data-v-19aca1e2]{margin-bottom:6px}.item span[data-v-19aca1e2]{font-size:16px}", "", {"version":3,"sources":["/workspace/src/views/midan/components/MidanPreviewDialog.vue"],"names":[],"mappings":"AACA,uBAAuB,iBAAiB,CACvC,AACD,4BAA4B,cAAc,CACzC","file":"MidanPreviewDialog.vue","sourcesContent":["\n.item[data-v-19aca1e2]{margin-bottom:6px\n}\n.item span[data-v-19aca1e2]{font-size:16px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19aca1e2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/midan/components/MidanPreviewDialog.vue
// module id = 1965
// module chunks = 49 139 156